import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { theme } from '../../../../theme/theme'
import { Modal } from '../../../modals/Modal'
import { Title3, BodyLarge } from '../../../styles/Typography'
import { OnClickButton } from '../../../buttons/onclick/OnClickButton'

type Props = {
  warnings: string[]
  onClose: () => void
  onExportAnyway: () => void
}

export const ExportWarningModal = ({ warnings, onClose, onExportAnyway }: Props) => {
  const { t } = useTranslation()

  return (
    <Modal onClose={onClose}>
      <Container>
        <Title3>{t('admin.statistics.exportWarningTitle')}</Title3>
        {warnings.map((warning) => (
          <BodyLarge key={warning}>{warning}</BodyLarge>
        ))}
        <ButtonRow>
          <OnClickButton text={t('common.form.cancel')} secondary onClick={onClose} />
          <OnClickButton text={t('admin.statistics.exportAnyway')} onClick={onExportAnyway} />
        </ButtonRow>
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.medium}px;
  max-width: 420px;
  text-align: center;
`

const ButtonRow = styled.div`
  display: flex;
  gap: ${theme.spacing.small}px;
  margin-top: ${theme.spacing.small}px;
`
